var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-spin-loading width-full height-full flex-center",staticStyle:{"background-color":"hsla(0, 0%, 100%, 0.9)"}},[_c('loading',_vm._b({staticClass:"container flex-col flex-center"},'loading',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }